// ---------------------------------------------------------------------------
// Config-admin module — i18n messages (de-AT)
// ---------------------------------------------------------------------------

export const configAdminLocales = {
  'de-AT': {
    admin: {
      config: {
        title: 'System-Konfiguration',
        subtitle: 'Globale Einstellungen und Aufbewahrungs-Policies.',
        tabs: {
          settings: 'Einstellungen',
          policies: 'Aufbewahrung',
        },
        settings: {
          empty: 'Keine Einstellungen vorhanden.',
          columns: {
            key: 'Schlüssel',
            value: 'Wert',
            type: 'Typ',
            category: 'Kategorie',
            description: 'Beschreibung',
            updated_at: 'Aktualisiert',
            actions: 'Aktionen',
          },
          secret_masked: 'Geheim',
          save: 'Speichern',
          saved: 'Gespeichert.',
          save_error: 'Speichern fehlgeschlagen.',
        },
        policies: {
          empty: 'Keine Policies definiert.',
          columns: {
            entity_type: 'Entitäts-Typ',
            retention_days: 'Tage',
            action: 'Aktion',
            description: 'Beschreibung',
            is_active: 'Aktiv',
            last_run_at: 'Letzter Lauf',
            actions: 'Aktionen',
          },
          action_delete: 'Löschen',
          action_anonymize: 'Anonymisieren',
          save: 'Speichern',
          saved: 'Gespeichert.',
          save_error: 'Speichern fehlgeschlagen.',
        },
      },
    },
  },
} as const;
